//#region src/modules/ServicePeriods/activity-evals/instance/status.ts
var ACTIVITY_EVAL_STATUSES = [
	"fulfilled",
	"missed",
	"partial",
	"pending"
];
var STATUS_LABELS = {
	fulfilled: "Fulfilled",
	missed: "Missed",
	partial: "Partial",
	pending: "Pending"
};
var STATUS_VARIANT = {
	fulfilled: "positive",
	missed: "critical",
	partial: "caution",
	pending: "neutral"
};
function aggregateStatusSummaries(summaries) {
	if (!summaries.length) return void 0;
	return summaries.reduce((acc, summary) => ({
		fulfilled: acc.fulfilled + summary.fulfilled,
		total: acc.total + summary.total
	}), {
		fulfilled: 0,
		total: 0
	});
}
function compactStatusSummaryVariant(statusSummary, options) {
	if (statusSummary.total > 0 && statusSummary.fulfilled === statusSummary.total) return "positive";
	if (options?.pending) return "neutral";
	if (statusSummary.fulfilled === 0) return "critical";
	return "caution";
}
function formatCompactStatusSummary(statusSummary) {
	return `${statusSummary.fulfilled}/${statusSummary.total}`;
}
function formatStatusSummary(statusSummary) {
	return `${statusSummary.fulfilled} of ${statusSummary.total}`;
}
//#endregion
export { ACTIVITY_EVAL_STATUSES, STATUS_LABELS, STATUS_VARIANT, aggregateStatusSummaries, compactStatusSummaryVariant, formatCompactStatusSummary, formatStatusSummary };

//# sourceMappingURL=status.js.map